module.exports = __webpack_public_path__ + "static/media/overlay4.e84e0dc0.png";